import { UseFormReturnType, isNotEmpty, useForm } from '@mantine/form'

import { ICreateClinicForm } from '../clinics.type'
import { openCreateLocationModal } from '../components/CreateClinicLocationModal/CreateClinicLocationModal.component'

export interface ICreateClinicHook {
  form: UseFormReturnType<Pick<ICreateClinicForm, 'name' | 'program'>>
  onSubmit: () => void
}

export const useCreateClinc = (): ICreateClinicHook => {
  const form = useForm<Pick<ICreateClinicForm, 'name' | 'program'>>({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      program: '',
    },
    validateInputOnBlur: true,
    validate: {
      name: isNotEmpty('Name is required'),
      program: isNotEmpty('Clinic Type is required'),
    },
  })

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      openCreateLocationModal(values.name, values.program)
    })()
  }

  return {
    form,
    onSubmit,
  }
}
